/* unplugin-vue-components disabled */import script from "./YImageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./YImageView.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./YImageView.vue?vue&type=style&index=0&id=46340f22&lang=postcss&module=css"
cssModules["css"] = style0

import exportComponent from "/root/workspace/njyx-frontend-pc_5kTN/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__